<ng-container *ngIf="orderResumeEnabled">
    <h4 class="fd-subtitle">Resumo do pedido</h4>
    <fd-table [tableDefinition]="tableDefinition"></fd-table>
</ng-container>